import { Link } from "components/elements";
import { TableRow, TableRowColumn, GrabsonIcon } from "components/layout";
import { ActionMenu, MenuItem } from "components/popups";
import { RestrictedArea, ROLES } from "containers/Permissions";
import { TiVoDeviceOem } from "hooks/tivoDevices";
import { useToggle } from "hooks/utils";
import { pathToUrl } from "utils/url";

import { PATHS } from "../../constants";
import { TEXTS } from "../constants";
import styles from "../TiVoDevices.scss";
import { TiVoDeviceSubRow } from "./TiVoDeviceSubRow";

interface TiVoDeviceRowProps {
  oem: TiVoDeviceOem;
  platformId: string;
}

export function TiVoDeviceRow({ oem, platformId }: TiVoDeviceRowProps) {
  const [expanded, toggleExpanded] = useToggle();
  const hasClients = oem.clientTypes && oem.clientTypes.length > 0;

  return (
    <>
      <TableRow>
        <TableRowColumn className={styles.name}>
          <div onClick={hasClients ? toggleExpanded : () => {}}>
            <GrabsonIcon
              className={hasClients ? styles.extender : styles.extenderHidden}
              name={
                hasClients ? (expanded ? "arrow-up" : "arrow-down") : "minus"
              }
              font="micro"
            />
            <Link
              to={pathToUrl(PATHS.detailsOem, { platformId, oemId: oem.id })}
            >
              {oem.name}
            </Link>
          </div>
        </TableRowColumn>
        <TableRowColumn>{oem.slug}</TableRowColumn>
        <TableRowColumn>
          <ActionMenu>
            <MenuItem
              to={pathToUrl(PATHS.detailsOem, { platformId, oemId: oem.id })}
            >
              {TEXTS.MENU.OEM_DETAILS}
            </MenuItem>
            <RestrictedArea
              allowed={[ROLES.tivoDevices.admin]}
              showFallback={false}
            >
              <MenuItem
                to={pathToUrl(PATHS.editOem, { platformId, oemId: oem.id })}
              >
                {TEXTS.MENU.OEM_EDIT}
              </MenuItem>
              <MenuItem
                to={pathToUrl(PATHS.createClientType, {
                  platformId,
                  oemId: oem.id,
                })}
              >
                {TEXTS.MENU.CLIENT_ADD}
              </MenuItem>
            </RestrictedArea>
          </ActionMenu>
        </TableRowColumn>
      </TableRow>
      {expanded &&
        oem.clientTypes?.map((clientType) => (
          <TiVoDeviceSubRow
            platformId={platformId}
            oemId={oem.id}
            clientType={clientType}
            key={clientType.id}
          />
        ))}
    </>
  );
}
